import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchData, urls } from '@internal/backstage-plugin-dh-dock-shared-common';

export interface GlobalProps {
  selectedGroup: string | null;
  projectMembersList:{
    id:number;
    count:number
  }[],
  isBusinessComponent:boolean;
  teamType:string;
  loading:boolean,
  error:string|null,
  appInitializationStatus:'idle' | 'in-progress' | 'succeeded' | 'failed';
  appInitializationError: string | null;
  appInitializationStartedAt: number | null;
  selectedKindLabel: string | null;
}


const initialState: GlobalProps = {
 selectedGroup:"",
 projectMembersList:[],
 isBusinessComponent:false,
 teamType:"",
 error:null,
 loading:true,
 appInitializationStatus:'idle',
 appInitializationError:null,
 appInitializationStartedAt:null,
 selectedKindLabel: null,
};
export const fetchProjectAsync = createAsyncThunk(
  'groups/getAllProjectsCount',
  async () => {
    const response = await fetchData(urls.getAllProjectsCount);
    return response;
  },
);

const authSlice = createSlice({
  name: 'globalVariable',
  initialState,
  reducers: {
    setSelectedGroups: (state, action: PayloadAction<string | null>) => {
      state.selectedGroup = action.payload;
    },
    setIsBusinessComponent:(state,action:PayloadAction<boolean>)=>{
      state.isBusinessComponent=action.payload
    },
    setTeamType:(state,action:PayloadAction<string>)=>{
      state.teamType=action.payload
    },
    setAppInitializationStarted: (state) => {
    state.appInitializationStatus = 'in-progress';
    state.appInitializationStartedAt = Date.now();
    state.appInitializationError = null;
  },

  setAppInitializationSucceeded: (state) => {
    state.appInitializationStatus = 'succeeded';
  },

  setAppInitializationFailed: (
    state,
    action: PayloadAction<string>
  ) => {
    state.appInitializationStatus = 'failed';
    state.appInitializationError = action.payload;
  },
  setSelectedKindValue: (state, action: PayloadAction<string | null>) => {
    state.selectedKindLabel = action.payload;
  },
  },


    extraReducers: builder => {
      builder
  
        .addCase(fetchProjectAsync.pending, state => {
          state.loading = true;
          state.error = null;
        })
  
        .addCase(
          fetchProjectAsync.fulfilled,
          (state, action: PayloadAction<any[]>) => {
            state.projectMembersList = action.payload;
            state.loading = false;
          },
        )
  
        .addCase(fetchProjectAsync.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Failed to fetch owners';
        });
        
    },
    
});

export const {setSelectedGroups,setIsBusinessComponent,setTeamType,setAppInitializationStarted,setAppInitializationSucceeded,setAppInitializationFailed,setSelectedKindValue} = authSlice.actions;
export default authSlice.reducer;
